var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.17207 18.854H4.10706C2.73057 18.854 1.61371 17.6995 1.61371 16.2861V3.71392C1.61371 2.29626 2.73469 1.14601 4.10706 1.14601H9.25449C9.56359 1.14601 9.81086 0.891341 9.81086 0.573005C9.81086 0.254669 9.56359 0 9.25449 0H4.10706C2.1165 0 0.500977 1.66808 0.500977 3.71392V16.2861C0.500977 18.3362 2.12062 20 4.10706 20H9.17207C9.48116 20 9.72844 19.7453 9.72844 19.427C9.72844 19.1087 9.47704 18.854 9.17207 18.854Z",
    fill: "#9B9B9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3377 9.59662L14.8016 5.95485C14.5832 5.72989 14.2329 5.72989 14.0145 5.95485C13.7961 6.17981 13.7961 6.54059 14.0145 6.76555L16.6026 9.43109H5.31455C5.00546 9.43109 4.75818 9.68576 4.75818 10.0041C4.75818 10.3224 5.00546 10.5771 5.31455 10.5771H16.6026L14.0145 13.2426C13.7961 13.4676 13.7961 13.8284 14.0145 14.0533C14.1216 14.1637 14.2659 14.2231 14.406 14.2231C14.5461 14.2231 14.6904 14.1679 14.7975 14.0533L18.3335 10.4116C18.5561 10.1824 18.5561 9.81734 18.3377 9.59662Z",
    fill: "#9B9B9B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.5300a9ab4c4a4b25bcbe8fde78f1e51c.svg";
export { ForwardRef as ReactComponent };